import axios from "@src/lib/request";

export const news = (data) => {
  return axios({
    method: "GET",
    url: `/public/primus/news`,
    data,
  });
};
